import {
    addToChainBefore,
} from "@insite/client-framework/HandlerCreator";
import { chain, UpdateContext } from "@insite/client-framework/Store/Context/Handlers/SetFulfillmentMethod";
import setUseOneTimeAddress from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetUseOneTimeAddress";

addToChainBefore(chain, UpdateContext, props => {
    if(props.parameter.fulfillmentMethod === "PickUp" && props.getState().pages.checkoutShipping.useOneTimeAddress) {
        props.dispatch(
            setUseOneTimeAddress({
                useOneTimeAddress: false,
            })
        );
    }
});